import {lazy} from 'react'

const appsRoute = [
  {
    key: 'elements.product',
    path: '/elements/product',
    component: lazy(() => import('../../Views/elements')),
    authority: 'secure',

  },
  {
    key: 'elements.cart',
    path: '/elements/cart',
    component: lazy(() => import('../../Views/elements')),
    authority: 'secure',

  }
]

export default appsRoute